import React from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
//import GetAllFormFields from '../../../../components/_utils/formUtils'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import { RightsWrapper } from '../../../../components/_utils/utils'
import { Button, Form, Input, InputNumber, notification, Popconfirm, Table, Card } from 'antd'
import _ from 'lodash'
import { hideLoader, showLoader } from '../../../../modules/actions'
import Request from '../../../../request'
import { connect } from 'react-redux'
import commonStyle from '../../../common.less'
import moment from 'moment'

let activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null

const FormItem = Form.Item

const EditableContext = React.createContext()

const EditableRow = ({ form, index, ...props }) => (
    <EditableContext.Provider value={form}>
        <tr {...props} />
    </EditableContext.Provider>
)

const EditableFormRow = Form.create()(EditableRow)

class EditableCell extends React.Component {
    getInput = () => {
        if (this.props.inputType === 'number') {
            return <InputNumber />
        }
        return <Input />
    }

    render() {
        const {
            editing,
            dataIndex,
            title,
            inputType,
            record,
            index,
            ...restProps
        } = this.props
        return (
            <EditableContext.Consumer>
                {form => {
                    const { getFieldDecorator } = form
                    return (
                        <td {...restProps}>
                            {editing ? (
                                <FormItem style={{ margin: 0 }}>
                                    {getFieldDecorator(dataIndex, {
                                        rules: [
                                            {
                                                required: true,
                                                message: `Please Input ${title}!`
                                            }
                                        ],
                                        initialValue: record[dataIndex]
                                    })(this.getInput())}
                                </FormItem>
                            ) : (
                                restProps.children
                            )}
                        </td>
                    )
                }}
            </EditableContext.Consumer>
        )
    }
}

@Form.create()
class AddState extends React.Component {
    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                dispatch(showLoader())
                let x = await Request.addState(values)
                dispatch(hideLoader())
                if (!x.error) {
                    notification.success({
                        message: 'Success',
                        description: x.msg
                    })

                    this.props.form.setFieldsValue({
                        stateName: null
                    })

                    this.refreshStatArr()

                    // dispatch('/all-countries')
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }
    state = {
        stateArr: [],
        editingKey: '',
        hidden: true,
        findName: '',
        loading: false,
        inputTypes: [
            {
                fields: [
                    {
                        label: 'Select Country ',
                        key: 'countryId',
                        required: true,
                        type: 'select',
                        options: [],
                        showSearch: true,
                        defaultValue: { key: 'Please Select' },
                        optionFilterProp: 'selectCountry',
                        onChange: v => {
                            console.log(v)
                            this.props.form.setFieldsValue({
                                countryId: v
                            })
                            this.loadStates(v)
                        }
                    },
                    { label: 'State Name', key: 'stateName', required: true }
                ]
            }
        ]
    }

    loadStates = id => {
        Request.loadStates(id)
            .then(daa => {
                daa.result = daa.result.reduce((total, val) => {
                    total.push({
                        key: val._id,
                        stateId: val.stateId,
                        name: val.stateName,
                        lastUpdatedByName: val.lastUpdatedByName,
                        createdByUser: val.createdByUser
                    })
                    return total
                }, [])

                this.setState({ arr: daa.result })
            })
            .catch(err => {
            })
    }

    loadAllCountries = () => {
        let params = {
            results: 100,
            sortField: 'countryName',
            sortOrder: 'ascend',
            businessId: activeUser && activeUser.businessId ? activeUser.businessId : ''
        }
        Request.getCountries(params)
            .then(resp => {
                if (resp) {

                    resp.data = resp.data.reduce((temp, vv) => {
                        vv.display = vv.countryName
                        vv.id = vv._id
                        temp.push(vv)
                        return temp
                    }, [])

                    let inputTypes = this.state.inputTypes
                    inputTypes[0].fields[0].options = resp.data

                    this.setState({ inputTypes: inputTypes })
                }
            })
            .catch(err => {
            })

        /* inputTypes[0].fields[0].customDirectives = {
               getValueFromEvent: this.getCountryValue
             }*/
    }
    refreshStatArr = () => {
        this.loadStates(this.props.form.getFieldValue('countryId'))
    }
    handleDelete = (val) => {
        Request.deleteState({ stateId: val })
            .then(x => {
                if (x.success) {
                    notification.success({
                        message: 'Success',
                        description: x.msg
                    })
                } else {
                    notification.error({
                        message: 'Error',
                        description: x.msg
                    })
                }
                this.refreshStatArr()
            })
            .catch(err => {
                console.log(err)
                notification.error({
                    message: 'Error',
                    description: 'Some Error'
                })
            })
    }


    constructor(props) {
        super(props)
        this.columns = [
            {
                title: 'State Name',
                dataIndex: 'name',
                width: '50%',
                editable: true
            },
            {
                title: 'Created By',
                key: 'createdByUser.name',
                dataIndex: 'createdByUser.name',
                render: (text, record) => {
                    console.log(record)
                    return (
                        <div>
                            <div>{record.createdByUser ? record.createdByUser.name : "NA"}</div>
                            <small>{record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
            {
                title: 'Last Updated By',
                key: 'updatedByUser.name',
                dataIndex: 'updatedByUser.name',
                render: (text, record) => {
                    console.log(record)
                    return (
                        <div>
                            <div>{record.updatedByUser ? record.updatedByUser.name : "NA"}</div>
                            <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },

            // {
            //     title: 'Last updated by',
            //     dataIndex: 'lastUpdatedByName',
            //     width: '25%',
            //     render: (val, record) => {
            //         return (
            //             <div>
            //                 <div className={commonStyle.user}>{record.lastUpdatedByName}</div>
            //             </div>
            //         )
            //     }
            // },

            {
                title: 'Actions',
                dataIndex: 'operation',
                render: (text, record) => {
                    const editable = this.isEditing(record)
                    return (
                        <div>
                            {editable ? (
                                <span>
                                    <EditableContext.Consumer>
                                        {form => (
                                            <a
                                                href="javascript:;"
                                                onClick={() => this.save(form, record.key)}
                                                style={{ marginRight: 8 }}>
                                                Save
                                            </a>
                                        )}
                                    </EditableContext.Consumer>
                                    <a onClick={() => this.cancel(record.key)}>Cancel</a>
                                </span>
                            ) : (
                                <div>
                                    <RightsWrapper myRight={'State.edit'}>
                                        <a onClick={() => this.edit(record.key)}>Edit</a>
                                    </RightsWrapper>
                                    <RightsWrapper myRight={'State.delete'}>
                                        <span style={{ marginLeft: 10 }}>
                                            <Popconfirm
                                                title="Sure to delete?"
                                                onConfirm={() => this.handleDelete(record.key)}>
                                                <a href="javascript:;">Delete</a>
                                            </Popconfirm>
                                        </span>
                                    </RightsWrapper>
                                </div>
                            )}
                        </div>
                    )
                }
            }
        ]
        this.loadAllCountries()
    }

    isEditing = record => record.key === this.state.editingKey

    componentDidMount() {
    }

    cancel = () => {
        this.setState({ editingKey: '' })
    }

    save(form, key) {
        form.validateFields((error, row) => {
            if (error) {
                return
            }

            Request.updateState({ stateName: row.name, _id: key })
                .then(x => {
                    if (x.success) {
                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })
                    } else {
                        notification.error({
                            message: 'Error',
                            description: x.msg
                        })
                    }

                    this.refreshStatArr()
                    this.setState({ editingKey: '' })
                })
                .catch(err => {
                    notification.error({
                        message: 'Error',
                        description: 'Some Error'
                    })
                    this.setState({ editingKey: '' })
                })
        })
    }

    edit(key) {
        this.setState({ editingKey: key })
    }

    render() {
        const { submitting } = this.props
        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props

        const components = {
            body: {
                row: EditableFormRow,
                cell: EditableCell
            }
        }

        const columns = this.columns.map(col => {
            if (!col.editable) {
                return col
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    inputType: col.dataIndex === 'age' ? 'number' : 'text',
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: this.isEditing(record)
                })
            }
        })

        return (
            <PageHeaderWrapper title={'Add New State'}>
                <div style={{ background: 'white' }}>
                    <div style={{ padding: 20 }}>
                        <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                            {this.state.inputTypes.map((itype, key) => {
                                return (
                                    <div key={key + 1}>
                                        <GetAllFormFields
                                            inputSchema={this.state.inputTypes[key]}
                                            getFieldDecorator={getFieldDecorator}
                                        />
                                    </div>
                                )
                            })}
                            <div style={{ textAlign: 'center' }}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                            </div>
                        </Form>
                    </div>

                    {this.state.arr && this.state.arr.length ? (
                        <div style={{ backgroundColor: 'white', padding: 10 }}>
                            <Card>
                                <h3>State: {this.state.arr.length}</h3>
                                <Table
                                    components={components}
                                    bordered
                                    dataSource={this.state.arr}
                                    columns={columns}
                                    rowClassName="editable-row"
                                />
                            </Card>

                        </div>
                    ) : null}
                </div>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddState)
